import { Button, Grid, Typography } from '@mui/material';

export function AnnotationComplete({ test, changeReviewComplete }) {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body">Face Status - {test.faceStatus}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body">Speech Status - {test.speechStatus}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body">Arms Status - {test.armsStatus}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body">Neurological Examination Status - {test.neurologicalExaminationStatus}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Button onClick={() => changeReviewComplete(false)} variant="text">
          Return for Review
        </Button>
      </Grid>
    </>
  );
}
